import styles from "~/pages/blog/blog-index.module.scss";
import MainNav from "~/components/navigation/MainNav";
import Footer from "~/components/Footer";
import CTA from "~/components/Common/CTA";
import { BLOG_FUNNEL } from "~/config/funnel";
import BlogBar from "~/components/navigation/BlogBar";

export default function Default(props) {
  const { children, blog_hide_tags } = props;

  return (
    <>
      <MainNav sticky bottom={<BlogBar blog_hide_tags={blog_hide_tags} />} />
      {children}
      <div className={styles["blog-index__cta-sticky-container"]}>
        <CTA page={"blog"} funnel={BLOG_FUNNEL} />
      </div>
      <Footer />
    </>
  );
}
